import { Component, Input, OnInit } from '@angular/core';
import { StatusResponse } from '../../../services/status.service';
import { ApproveResponse } from '../../../services/approve.service';

@Component({
  selector: 'ab-payment-pending',
  templateUrl: './payment-pending.component.html',
  styleUrls: ['./payment-pending.component.scss']
})
export class PaymentPendingComponent implements OnInit {
  @Input() merchantInfo: Partial<StatusResponse & ApproveResponse>;
  constructor() {}

  ngOnInit(): void {}

  redirectToMerchant() {
    window.location.href = this.merchantInfo.returnUrl || this.merchantInfo.url;
  }
}
